'use strict';

module.exports = {
  isCircle: function (layer) {
    var type;

    if (typeof layer === 'string') {
      type = layer.toLowerCase();
    } else {
      console.log('DEPRECATED');
      type = layer.type.toLowerCase();
    }

    return type === 'circle';
  },

  getLeafletLayer: function (latlng, radius, options) {
    return L.circle(latlng, radius, options);
  }
};


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/map/src/app/layer/transform/geojson/annotation/lib/CircleUtil.js